<div mat-dialog-title>
  <div class="dialog-header-title">Global User Management</div>
</div>

<mat-dialog-content>
  {{'About.Version' | translate}}: v{{version}}
</mat-dialog-content>
